export const setupIntent = async (
    API_URL: string,
    token: string,
    employerId: string
) => {
    const response = await fetch(
        `${API_URL}/stripe-payments/setup-intent`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            employerId: employerId
          })
        }
      );

      return await response.json();
}